module.exports = __webpack_public_path__ + "static/media/cavendish_bananas.f9adf1f0.jpg";